/**
 * Vault: a local, encrypted secrets manager — passwords, SFTP connections,
 * auth headers, notes and custom items. Like Chat and Documents it is
 * HOST-RENDERED (VaultSidebar.js + VaultView.js) rather than sandboxed: the
 * vault talks to the Rust vault commands (vault_status / vault_unlock /
 * vault_list / …) directly via invoke, and secret material must never cross
 * into a guest iframe. The guest entry.js is a no-op kept only to satisfy the
 * registration contract.
 *
 * The icon-rail slot sits right after Chat; clicking it opens the vault panel
 * (App.js `activeTab === 'vault.panel'` branch → VaultSidebar as the sidebar,
 * VaultView as the content — chat-style, no tab strip).
 */
export const vaultManifest = {
  schemaVersion: 1,
  id: 'com.apiboo.vault',
  name: 'Vault',
  version: '0.1.0',
  publisher: 'apiboo',
  entry: 'dist/main.js',
  icon: 'lock',
  engines: { apibooSdk: '^1.0.0' },
  // HOST-RENDERED, not sandboxed: the panel above is a first-party React
  // component calling Tauri directly, so `permissions: []` means "declares no
  // GUEST capabilities", not "has no access". Settings reads this flag to say
  // that plainly instead of showing an empty permission list that implies a
  // control the user does not have — see EXT-05.
  hostRendered: true,
  permissions: [],
  contributes: {
    activityBar: [
      { id: 'vault.activity', title: 'Vault', icon: 'lock', order: { after: 'chat.activity' } },
    ],
    panels: [{ id: 'vault.panel', activityBarId: 'vault.activity', title: 'Vault' }],
    settings: [],
  },
};
